import React from 'react';

const InputField = ({ label, value, onChange, ...props }) => (
  <div className="flex flex-col space-y-1">
    <label className="block text-md font-medium text-gray-700 dark:text-gray-300 mb-2">{label}</label>
    <input
      type={props.type || "number"}
      value={value}
      onChange={onChange}
      className="w-full px-4 py-3 bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-cyan-400 border border-gray-300 dark:border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg transition duration-200"
      placeholder={props.placeholder || `e.g., ${label.includes('PTV') ? '85' : '60'}`}
      {...props}
    />
  </div>
);

export default InputField;